import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { TransferState, makeStateKey } from '@angular/core';
// rxjs
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/take';
//import 'rxjs/add/operator/retry';
import { take, takeWhile, map, catchError, retry } from 'rxjs/operators';

// models
import { AppState } from '../../booking/models/app-state.interface';
import { AirportCopyDataInitState } from '../models/copy.interface';
// path globals
import { API_PATH, SUBSCRIPTION_KEY, SYSTEM_OBJECTS, GET_COPY_DATA, GET_AIRPORT_COPY_DATA, ABC_PARTNERS } from '../globals';
// server state key
const COPY_KEY = makeStateKey('copy');

let copyResponseData = null;

@Injectable({
  providedIn: 'root',
})
export class AirportCopyService {
  private _copyStoreData: AirportCopyDataInitState = null;
  private _copyRequested: boolean = false;

  public copyData$: Subject<any> = new Subject();

  constructor(
    private _appStore: Store<AppState>,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _serverState: TransferState
  ) { }

  getStaticCopy() {
    if (this._copyRequested) { return; }
    this._copyRequested = true;
    this._http.get(GET_AIRPORT_COPY_DATA)
      .subscribe((res: any) => {
        const copyStoreData: AirportCopyDataInitState = res;
        this._copyStoreData = res;
        copyStoreData.copyLoaded = true;
        copyResponseData = copyStoreData;
        this._appStore.dispatch({ type: 'AIRPORT_COPY_LOADED', payload: true });
      });
  }

  getAirportsCopy() {
    return copyResponseData;
  }

  getCopyByAirportCode(airportCode: string) {
    const airportCopy = copyResponseData;
    return airportCopy[airportCode];
  }

}
